<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Generate Report </div>
  <div class=" profile_details selectColumn">
    <div class="page__content shadow p-3" style="min-height: calc(76vh - 80px) !important;">
      <!-- <div class="col-md-6"> -->
      <div class="selectlist">
        <p style="font-size: 14px !important;">Please select the column you want to be included in the generated Excel
          Sheet

        </p>
      </div>
      <mat-list-item>
        <mat-checkbox style="float: right;font-size: 13px !important;
                          margin-top: -24px !important;" class="custom-frame" [(ngModel)]="masterSelected"
          name="list_name" value="m1" (change)="checkUncheckAll()"><b>Select All</b></mat-checkbox>
      </mat-list-item>
      <div class="row">
        <mat-list-item class="col-md-4" style="padding-left: 66px;" *ngFor="let item of checklist">
          <mat-checkbox class="custom-frame" [(ngModel)]="item.isSelected" name="list_name" value="{{item.id}}"
            (change)="isAllSelected()">
            {{item.viewValue}}</mat-checkbox>
        </mat-list-item>
      </div>
      <!-- </div> -->
      <!--for testing to getting any value or not  <div class="col-md-6">
                    <code>{{checkedList}}</code>
                  </div> -->
      <hr>
      <div class="button" style="float:right;margin-top:-20px!important;">
        <button mat-raised-button class="btn btncls" (click)="closeDialog()">Generate report</button>&nbsp;
        <button mat-raised-button class="btn btncls" (click)="closeDialogtest()">close</button>
      </div>
    </div>
  </div>
</div>
<style>
  .page__content {
    min-height: calc(76vh - 80px) !important;
    border-radius: 10px;
    margin-top: -2rem;
    background: white;
    color: black;
    font-size: 2rem;
  }

  ::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background {
    background-color: #90b93d !important;
  }

  /* mat-checkbox#mat-checkbox-8{
      font-size: 13px !important;
      margin-top: -24px !important;
  } */
  mat-checkbox {
    font-size: 17px !important;
  }

  ::ng-deep .mat-checkbox-frame {
    border-radius: 70% !important;
  }

  ::ng-deep.mat-checkbox-background {
    border-radius: 70% !important;
  }

  .btncls {
    color: white;
    background-color: #234a90;
  }
</style>